import React from 'react';
import * as S from './styles';

interface CheckboxFieldProps {
    id: string;
    checked: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    checkboxColor: string;
    textColor: string;
    children: React.ReactNode;
    decorate?: boolean;
    style?: React.CSSProperties;
}

export const CheckboxField = ({
    id,
    checked,
    onChange,
    checkboxColor,
    textColor,
    children,
    decorate = false,
    style = {},
}: CheckboxFieldProps) => (
    <S.Row style={style}>
        <S.Input
            type="checkbox"
            id={id}
            checked={checked}
            onChange={onChange}
            $checkboxColor={checkboxColor}
        />
        <S.Label htmlFor={id} $textColor={textColor} $decorate={decorate}>
            {children}
        </S.Label>
    </S.Row>
);

export { S as CheckboxFieldStyles };
